import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBurger = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 48,
	height: 48,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		stroke: "#444",
		strokeWidth: 2,
		strokeLinecap: "round",
		d: "M15 16h18M15 23h12M15 30h18"
	})
});
export default SvgBurger;
